var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoSmoking(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1rem",
    height: "1rem",
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 3",
    d: "M1.8125 11.2661C1.8125 10.7138 2.26022 10.2661 2.8125 10.2661H5.42324V14.4224H2.8125C2.26022 14.4224 1.8125 13.9746 1.8125 13.4224V11.2661Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 4",
    d: "M19.5313 13.4224V11.2661C19.5313 10.7138 19.0835 10.2661 18.5313 10.2661H11.5074H9.90262H8.29785V14.4224H12.3098H14.7169H18.5313C19.0835 14.4224 19.5313 13.9746 19.5313 13.4224Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 9",
    d: "M4.6875 2.24243L16.7233 18.2901",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 10",
    d: "M15.7058 1.29834C15.5052 1.47665 15.1442 2.04723 15.3046 2.90311C15.5052 3.97296 16.7088 4.24042 16.107 6.64758",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 11",
    d: "M18.4861 1.29834C18.2855 1.47665 17.9244 2.04723 18.0849 2.90311C18.2855 3.97296 19.4891 4.24042 18.8873 6.64758",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoSmoking);
export default __webpack_public_path__ + "static/media/no-smoking.e24b737d02d0053f5c2f65966af60345.svg";
export { ForwardRef as ReactComponent };